<template>
  <div class="msg-list">
    <div class="table-bd">
      <custom-table tableCode="role_msg_list" :data="tableList" @filter="filterChange" @sort="sortChange" height="100%"></custom-table>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  props: {
    roleId: [String, Number],
    orgId: [String, Number]
  },
  data() {
    return {
      tableList: []
    };
  },
  watch: {
    roleId(val) {
      if (val) {
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.RoleMsgTemplateList, {
        roleId: this.roleId,
        orgId: this.orgId
      }).then((res) => {
        this.tableList = res.data;
      });
    }
  },
  mounted() {
    this.getTableList();
  }
};
</script>

<style lang="scss" scoped>
.msg-list {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.empty-tips {
  text-align: center;
  display: flex;
  height: 100%;
  color: #909399;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
</style>
